const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const STYLE = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Georgia, 'Times New Roman', serif; color: #111; }
  .slip { padding: 40px 44px; max-width: 720px; margin: 0 auto; page-break-after: always; }
  .slip:last-child { page-break-after: auto; }
  .brand { text-align: center; letter-spacing: 0.35em; font-size: 17px; text-transform: uppercase; }
  .brand small { display: block; letter-spacing: 0.25em; font-size: 9px; color: #777; margin-top: 5px; }
  .rule { border: none; border-top: 1px solid #111; margin: 20px 0; }
  .meta { display: flex; justify-content: space-between; gap: 24px; font-size: 12px; margin-bottom: 22px; }
  .meta h3 { font-size: 9px; letter-spacing: 0.25em; text-transform: uppercase; color: #888; margin-bottom: 6px; font-weight: normal; }
  .meta .big { font-size: 15px; }
  .meta .right { text-align: right; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th { text-align: left; font-size: 9px; letter-spacing: 0.25em; text-transform: uppercase; color: #888; font-weight: normal; padding: 0 6px 7px 0; border-bottom: 1px solid #111; }
  td { padding: 10px 6px 10px 0; border-bottom: 1px solid #ddd; vertical-align: top; }
  td.qty { width: 46px; font-size: 16px; }
  td.tick { width: 52px; text-align: center; font-size: 17px; color: #444; }
  th.tick-h { text-align: center; }
  .size { color: #666; }
  .note { display: block; font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; color: #996a00; margin-top: 2px; }
  .section { font-size: 10px; letter-spacing: 0.25em; text-transform: uppercase; color: #888; margin: 22px 0 8px; }
  .footer { margin-top: 34px; text-align: center; font-size: 12px; color: #444; }
  .footer .thanks { font-size: 15px; color: #111; margin-bottom: 8px; }
  .disclaimer { margin-top: 16px; font-size: 9px; letter-spacing: 0.06em; text-transform: uppercase; color: #999; border-top: 1px solid #ddd; padding-top: 12px; }
  @media print { .slip { padding: 10mm 8mm; } }
`;

function slipBody(order, slipNote) {
  const cust = order.customer || {};
  const physical = (order.items || []).filter((it) => !it.digital && (it.qty || 0) > 0);
  const toPack = physical.filter((it) => !it.preorder);
  const toFollow = physical.filter((it) => it.preorder);
  const freebies = order.freebies || [];
  const date = new Date(order.createdAt || Date.now()).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });

  const row = (qty, name, size, note) => `
    <tr>
      <td class="qty">${qty}&times;</td>
      <td>${esc(name)}${size ? `<span class="size"> &middot; ${esc(size)}</span>` : ''}${note ? `<span class="note">${note}</span>` : ''}</td>
      <td class="tick">&#9744;</td>
    </tr>`;

  return `<div class="slip">
  <div class="brand">Australian Luxe Peptides<small>Packing Slip</small></div>
  <hr class="rule">
  <div class="meta">
    <div>
      <h3>Deliver To</h3>
      <div class="big">${esc(cust.fullName || '')}</div>
      <div>${esc(cust.address || '')}</div>
      <div>${esc([cust.city || cust.suburb, cust.state, cust.postcode].filter(Boolean).join(', '))}</div>
      ${cust.phone ? `<div>${esc(cust.phone)}</div>` : ''}
    </div>
    <div class="right">
      <h3>Order</h3>
      <div class="big">${esc(order.orderNumber)}</div>
      <div>${esc(date)}</div>
    </div>
  </div>
  <table>
    <thead><tr><th>Qty</th><th>Item</th><th class="tick-h">Packed</th></tr></thead>
    <tbody>
      ${toPack.map((it) => row(it.qty, it.name, it.size, '')).join('')}
      ${freebies.map((f) => row(f.qty, f.name, f.size, 'Complimentary &mdash; with our thanks')).join('')}
    </tbody>
  </table>
  ${toFollow.length ? `
  <div class="section">To Follow &mdash; ships separately</div>
  <table>
    <tbody>
      ${toFollow.map((it) => `<tr><td class="qty">${it.qty}&times;</td><td>${esc(it.name)}${it.size ? `<span class="size"> &middot; ${esc(it.size)}</span>` : ''}<span class="note">Preorder &mdash; on its way to you soon</span></td><td class="tick"></td></tr>`).join('')}
    </tbody>
  </table>` : ''}
  <div class="footer">
    <div class="thanks">${esc((slipNote || '').trim() || 'Thank you for your order.')}</div>
    <div>Questions? support@australianluxepeptides.com</div>
    <div class="disclaimer">All products are supplied strictly for research purposes only. Not for human consumption.</div>
  </div>
</div>`;
}

function openPrint(title, bodies) {
  const html = `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"><title>${esc(title)}</title><style>${STYLE}</style></head>
<body>
  ${bodies.join('\n')}
</body>
</html>`;
  // Print via hidden iframe so the app stays open (a popup window traps PWA users with no way back).
  const prev = document.getElementById('alp-print-frame');
  if (prev) prev.remove();
  const frame = document.createElement('iframe');
  frame.id = 'alp-print-frame';
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  document.body.appendChild(frame);
  frame.onload = () => {
    const win = frame.contentWindow;
    win.onafterprint = () => setTimeout(() => frame.remove(), 500);
    setTimeout(() => { win.focus(); win.print(); }, 150);
  };
  frame.srcdoc = html;
  return true;
}

export function printPackingSlip(order, slipNote) {
  return openPrint(`Packing Slip ${order.orderNumber}`, [slipBody(order, slipNote)]);
}

export function printPackingSlips(orders, slipNote) {
  if (!orders.length) return false;
  return openPrint(`Packing Slips (${orders.length})`, orders.map((o) => slipBody(o, slipNote)));
}
